import * as React from 'react';

import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import Header from "../components/Header";

export default function ServiceWorkerReload({onClick,...props}) {

    return (
        <Container component="main" maxWidth="sm">
            <Header label="Application Update" />

            <Grid container columnSpacing={2} rowSpacing={2}>
                <Grid xs={12}> 
                    <Typography variant="body1">A new version of the application is ready. This requires a full closing of the web application or completely closing down your browser. In your browser, you can also do a force reload, by holding Shift and clicking the reload button.</Typography>    
                </Grid>

            </Grid>
        </Container>
    );
}